let nativeFetch = typeof window !== 'undefined' && window.fetch ? window.fetch.bind(window) : globalThis.fetch;

export function _setNativeFetchForTesting(mock) {
  nativeFetch = mock;
}

export function _resetNativeFetchForTesting() {
  nativeFetch = typeof window !== 'undefined' && window.fetch ? window.fetch.bind(window) : globalThis.fetch;
}

function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;
  const entry = document.cookie.split('; ').find((item) => item.startsWith(prefix));
  return entry ? decodeURIComponent(entry.slice(prefix.length)) : null;
}

function csrfCookie(hostName, developmentName) {
  return readCookie(hostName) || readCookie(developmentName);
}

function csrfToken(input) {
  const raw = typeof input === 'string' ? input : input?.url;
  const path = new URL(raw, window.location.origin).pathname;
  if (path.startsWith('/api/mobile/device/scan/')) {
    return csrfCookie('__Host-gema-device-scan-csrf', 'gema-device-scan-csrf');
  }
  if (path.startsWith('/api/mobile/device/consent/')) {
    return csrfCookie('__Host-gema-device-consent-csrf', 'gema-device-consent-csrf');
  }
  if (path.startsWith('/api/patient/registration/')) {
    return csrfCookie('__Host-gema-patient-registration-csrf', 'gema-patient-registration-csrf');
  }
  if (path === '/api/reviews/submit') {
    return csrfCookie('__Host-gema-review-csrf', 'gema-review-csrf');
  }
  return csrfCookie('__Host-gema_csrf', 'gema_csrf');
}

function isSameOriginApi(input) {
  const raw = typeof input === 'string' ? input : input?.url;
  if (!raw) return false;
  const url = new URL(raw, window.location.origin);
  return url.origin === window.location.origin && url.pathname.startsWith('/api/');
}

export async function apiFetch(input, init = {}) {
  if (!isSameOriginApi(input)) return nativeFetch(input, init);

  const method = String(init.method || (typeof input !== 'string' && input?.method) || 'GET').toUpperCase();
  const headers = new Headers(init.headers || (typeof input !== 'string' ? input?.headers : undefined));
  headers.delete('Authorization');
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const token = csrfToken(input);
    if (token) headers.set('X-CSRF-Token', token);
  }
  const response = await nativeFetch(input, { ...init, method, headers, credentials: 'same-origin' });
  if (response.status === 401) {
    const raw = typeof input === 'string' ? input : input?.url;
    try {
      const path = new URL(raw, window.location.origin).pathname;
      const isPublicOrDeviceEndpoint =
        path.startsWith('/api/public/') ||
        path.startsWith('/api/mobile/device/') ||
        path.startsWith('/api/patient/registration/') ||
        path.startsWith('/api/reviews/') ||
        path === '/api/auth/csrf' ||
        path === '/api/auth/login';
      if (!isPublicOrDeviceEndpoint) {
        console.warn('[apiClient] 401 Unauthorized received on authenticated endpoint:', path, '-> dispatching gema:unauthorized');
        window.dispatchEvent(new CustomEvent('gema:unauthorized'));
      } else {
        console.info('[apiClient] 401 received on public/device endpoint (no global logout triggered):', path);
      }
    } catch {
      window.dispatchEvent(new CustomEvent('gema:unauthorized'));
    }
  }
  return response;
}

export function installApiClient() {
  if (window.fetch === apiFetch) return;
  window.fetch = apiFetch;
}

export async function establishCsrf() {
  const response = await apiFetch('/api/auth/csrf', { cache: 'no-store' });
  if (!response.ok) throw new Error('No se pudo iniciar una sesión segura');
  return response.json();
}
